import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { CleanerBookingDetail } from '@/features/cleaner/booking-detail';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

const bookingDetailSearchSchema = z.object({
  ref: z
    .enum(['dashboard', 'bookings', 'notifications'])
    .optional()
    .default('bookings'),
  status: z.enum(['upcoming', 'history', 'all']).optional(),
  section: z.string().optional(),
  showReviewModal: z.string().optional(),
  view: z.string().optional(),
});

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/bookings/$id'
)({
  component: CleanerBookingDetailPage,
  validateSearch: bookingDetailSearchSchema,
});

function CleanerBookingDetailPage() {
  const navigate = useNavigate();
  const { ref, status } = Route.useSearch();
  const { id: bookingId } = Route.useParams();

  const handleBack = () => {
    switch (ref) {
      case 'dashboard':
        navigate({ to: '/cleaner/dashboard' });
        break;
      case 'notifications':
        navigate({ to: '/cleaner/notifications' });
        break;
      case 'bookings':
      default:
        navigate({
          to: '/cleaner/bookings',
          search: { status: status ?? 'upcoming' },
        });
        break;
    }
  };

  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton onClick={handleBack} />
        <HeaderDashboard.Title>Bookings</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <CleanerBookingDetail bookingId={bookingId} />
      </div>
    </div>
  );
}
